import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import ListItem from "@material-ui/core/ListItem";
import arrow from "../../assets/images/arrow.png";

import Box from "@material-ui/core/Box";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import clsx from "clsx";
import Link from "@material-ui/core/Link";
import moment from "moment";
import api from "../common/dependencies/utils/Api";
import { COHORT_PROGRAM_TOTAL_MENTORS } from "../common/constants/ApplicationUrl";
import { Typography } from "@material-ui/core";
import "./styles.scss";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../common/constants/actionConstants";
const useStyles = makeStyles((theme) => ({
  table: {},
  tableRightBorder: {
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
    borderStyle: "solid",
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  objectFit: {
    objectFit: "contain",
  },
  tableFont: {
    fontSize: "16px",
    fontFamily: "Montserrat",
    maxWidth:"19.5rem"
  },
  tableInitFont: {
    fontSize: "16px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#b499c7",
    maxWidth:"12rem"
  },
  tableHeader: {
    fontSize: "18px",
    fontFamily: "Montserrat",
    color: "#277acc",
    fontWeight: 600,
    padding: "10px 0 !important",
  },
  root: {
    boxShadow: theme.shadows[2],
    marginTop: "30px",
    borderRadius: "20px",
    overflow: "hidden",
  },
}));

export default function BasicTable(props) {
  const [mentorlist, setMentorlist] = useState();
  const classes = useStyles();
  const [toggleMentor, setToggleMentor] = useState(false);

  useEffect(() => {
    let param = {
      cohortId: props.data?.cohortId,
    };
    api
      .POST(COHORT_PROGRAM_TOTAL_MENTORS, {
        cohortId: props.data?.cohortId,
      })
      .then((res) => {
        setMentorlist(res?.data?.data);
        // props.closeLoader();
      })
      .catch((err) => {
        // props.closeLoader();
      });
  }, [props]);
  // api
  //   .POST(COHORT_PROGRAM_TOTAL_MENTORS, {
  //     cohortId: props.data?.cohortId,
  //   })
  //   .then((res) => {
  //     // props.closeLoader();
  //   })
  //   .catch((err) => {
  //     // props.closeLoader();
  //   });
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  return (
    <Box className={classes.root}>
      <TableContainer sx={{ overflow: "hidden" }} component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableBody>
            <TableRow>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableInitFont,
                  "homepageFirstDescription"
                )}
              >
                ORGANIZATION NAME
              </TableCell>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableFont,
                  "homepageFirstDescription"
                )}
              >
                {props.data?.organization_name}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableInitFont,
                  "homepageFirstDescription"
                )}
              >
                ORGANIZATION TYPE
              </TableCell>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableFont,
                  "homepageFirstDescription"
                )}
              >
                {props.data?.organization_type}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableInitFont,
                  "homepageFirstDescription"
                )}
              >
                APPLICATION START DATE FOR STARTUPS
              </TableCell>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableFont,
                  "homepageFirstDescription"
                )}
              >
                {moment(props.data?.startup_start_date).format("Do MMMM YYYY")}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableInitFont,
                  "homepageFirstDescription"
                )}
              >
                APPLICATION END DATE FOR STARTUPS
              </TableCell>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableFont,
                  "homepageFirstDescription"
                )}
              >
                {moment(props.data?.startup_end_date).format("Do MMMM YYYY")}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableInitFont,
                  "homepageFirstDescription"
                )}
              >
                NO. OF MENTORS (Proposed)
              </TableCell>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableFont,
                  "homepageFirstDescription"
                )}
              >
                {props.data?.numberofmentors}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableInitFont,
                  "homepageFirstDescription"
                )}
              >
                NO. OF STARTUPS FOR EACH MENTOR
              </TableCell>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableFont,
                  "homepageFirstDescription"
                )}
              >
                {props.data?.numberofstartups}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableInitFont,
                  "homepageFirstDescription"
                )}
              >
                INDUSTRY
              </TableCell>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableFont,
                  "homepageFirstDescription"
                )}
              >
                {props.data?.industry.length > 0 &&
                props.data?.industry.length == 1
                  ? props.data?.industry?.map((item) => <>{item} </>)
                  : props.data?.industry?.map((item) => <>{item}, </>)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableInitFont,
                  "homepageFirstDescription"
                )}
              >
                SPECIALIZATION
              </TableCell>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableFont,
                  "homepageFirstDescription"
                )}
              >
                {props.data?.specialization.length > 0 &&
                props.data?.specialization.length == 1
                  ? props.data?.specialization?.map((item) => <>{item} </>)
                  : props.data?.specialization?.map((item) => <>{item}, </>)}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableInitFont,
                  "homepageFirstDescription"
                )}
              >
                STAGE
              </TableCell>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableFont,
                  "homepageFirstDescription"
                )}
              >
                {props.data?.preferred_stage[0]}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableInitFont,
                  "homepageFirstDescription"
                )}
              >
                AVG. MENTORSHIP HOURS PER WEEK
              </TableCell>
              <TableCell
                className={clsx(
                  classes.tableRightBorder,
                  classes.tableFont,
                  "homepageFirstDescription"
                )}
              >
                {props.data?.hoursperweek}
              </TableCell>
            </TableRow>
            {mentorlist && mentorlist != null && (
              <TableRow>
                <TableCell
                  className={clsx(
                    classes.tableRightBorder,
                    classes.tableInitFont,
                    "homepageFirstDescription"
                  )}
                >
                  TOTAL MENTORS
                </TableCell>
                {/* {mentorlist && mentorlist?.length > 5 && !toggleMentor ? (
                  <>
                    <TableCell
                      className={clsx(
                        classes.tableRightBorder,
                        classes.tableFont,
                        "homepageFirstDescription"
                      )}
                    >
                      {mentorlist &&
                        mentorlist.map((item, index) => {
                          if (index < 5)
                            return (
                              <>
                                <ListItem
                                  style={{
                                    paddingLeft: "0px",
                                    borderBottom:
                                      index === mentorlist?.length - 1
                                        ? "none"
                                        : "lightgrey solid 1px",
                                  }}
                                >
                                  <ListItemAvatar>
                                    <Avatar
                                      classes={{
                                        img: classes.objectFit,
                                      }}
                                      src={item?.image}
                                    />
                                  </ListItemAvatar>
                                  <p
                                    className="hovermentorname"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      window.open(
                                        `/mentor-profile/${item.id}`,
                                        "_blank"
                                      );
                                    }}
                                  >
                                    {item?.name}
                                  </p>
                                </ListItem>
                                {mentorlist?.length > 4 && index == 4 ? (
                                  <td
                                    className="session-answer answersession2"
                                    // style={{ minWidth: "33rem" }}
                                  >
                                    <div
                                      className="d-flex"
                                      onClick={() => setToggleMentor(true)}
                                    >
                                      <div
                                        className="color-green21"
                                        style={{
                                          position: "relative",
                                          left: "-0.35rem",
                                          top: "-0.1rem",
                                        }}
                                      >
                                        View More
                                      </div>
                                      <div
                                        style={{
                                          cursor: "pointer",
                                          bottom: "0.5rem",
                                          right: "1.25rem",
                                        }}
                                        className="arrowCollapse"
                                      >
                                        <img
                                          style={{ width: "70%" }}
                                          src={arrow}
                                        />
                                      </div>
                                    </div>
                                  </td>
                                ) : (
                                  ""
                                )}
                              </>
                            );
                        })}
                    </TableCell>
                  </>
                ) : (
                  mentorlist &&
                  mentorlist.map(function (item, index) {
                    return (
                      <>
                        <TableCell
                          className={clsx(
                            classes.tableRightBorder,
                            classes.tableFont,
                            "homepageFirstDescription"
                          )}
                        >
                          <ListItem
                            style={{
                              paddingLeft: "0px",
                              borderBottom:
                                index === mentorlist?.length - 1
                                  ? "none"
                                  : "lightgrey solid 1px",
                            }}
                          >
                            <ListItemAvatar>
                              <Avatar
                                classes={{
                                  img: classes.objectFit,
                                }}
                                src={item?.image}
                              />
                            </ListItemAvatar>
                            <p
                              className="hovermentorname"
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                window.open(
                                  `/mentor-profile/${item.id}`,
                                  "_blank"
                                );
                              }}
                            >
                              {item?.name}
                            </p>
                          </ListItem>

                          {index === mentorlist?.length - 4 &&
                          mentorlist?.length > 5 ? (
                            <td
                              className="session-answer answersession2"
                              // style={{ minWidth: "33rem" }}
                            >
                              <div
                                className="d-flex"
                                onClick={() => setToggleMentor(false)}
                              >
                                <div
                                  className="color-green21"
                                  style={{
                                    position: "relative",
                                    left: "-0.35rem",
                                    top: "-0.1rem",
                                  }}
                                >
                                  View Less
                                </div>
                                <div
                                  style={{
                                    cursor: "pointer",
                                    bottom: "0.5rem",
                                    left: "-0.35rem",
                                  }}
                                  className="arrowCollapse2"
                                >
                                  <img style={{ width: "70%" }} src={arrow} />
                                </div>
                              </div>
                            </td>
                          ) : (
                            ""
                          )}
                        </TableCell>
                      </>
                    );
                  })
                )} */}
                <TableCell
                  className={clsx(
                    classes.tableRightBorder,
                    classes.tableFont,
                    "homepageFirstDescription"
                  )}
                > 
               
                  {mentorlist &&
                    !toggleMentor &&
                    mentorlist.map((item, index) => {
                      if (index < 5)
                        return (
                          <>
                            <ListItem
                              style={{
                                paddingLeft: "0px",
                                borderBottom:
                                  index ===
                                  (mentorlist?.length > 5
                                    ? 4
                                    : mentorlist?.length - 1)
                                    ? "none"
                                    : "lightgrey solid 1px",
                              }}
                            >
                              <ListItemAvatar>
                                <Avatar
                                  classes={{
                                    img: classes.objectFit,
                                  }}
                                  src={item?.image}
                                />
                              </ListItemAvatar>
                              <p
                                className="hovermentorname"
                                style={{
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  window.open(`/mentor-profile/${encryptAES2(item?.id,PROFILE_KEY)}`, "_blank");

                                  // window.open(
                                  //   `/mentor-profile/${item.id}`,
                                  //   "_blank"
                                  // );
                                }}
                              >
                                {item?.name}
                              </p>
                            </ListItem>
                            {mentorlist?.length > 5 && index == 4 ? (
                              <td
                                className="session-answer answersession2"
                                style={{ minWidth: "0rem", paddingTop: "15px" }}
                              >
                                <div
                                  className="d-flex"
                                  onClick={() => setToggleMentor(true)}
                                >
                                  <div
                                    className="color-green21"
                                    style={{
                                      position: "relative",
                                      left: "-0.35rem",
                                      top: "-0.1rem",
                                    }}
                                  >
                                    View More
                                  </div>
                                  <div
                                    style={{
                                      cursor: "pointer",
                                      bottom: "0.5rem",
                                      right: "1.25rem",
                                    }}
                                    className="arrowCollapse"
                                  >
                                    <img style={{ width: "70%" }} src={arrow} />
                                  </div>
                                </div>
                              </td>
                            ) : (
                              ""
                            )}
                          </>
                        );
                    })}
                  {mentorlist &&
                    toggleMentor &&
                    mentorlist.map((item, index) => {
                      // if (index < 5)
                      return (
                        <>
                          <ListItem
                            style={{
                              paddingLeft: "0px",
                              borderBottom:
                                index === mentorlist?.length - 1
                                  ? "none"
                                  : "lightgrey solid 1px",
                            }}
                          >
                            <ListItemAvatar>
                              <Avatar
                                classes={{
                                  img: classes.objectFit,
                                }}
                                src={item?.image}
                              />
                            </ListItemAvatar>
                            <p
                              className="hovermentorname"
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                window.open(`/mentor-profile/${encryptAES2(item?.id,PROFILE_KEY)}`, "_blank");
                                // window.open(
                                //   `/mentor-profile/${item.id}`,
                                //   "_blank"
                                // );
                              }}
                            >
                              {item?.name}
                            </p>
                          </ListItem>
                          {index === mentorlist?.length - 1 &&
                          mentorlist?.length > 5 ? (
                            <td
                              className="session-answer answersession2"
                              style={{ minWidth: "0rem", paddingTop: "15px" }}
                            >
                              <div
                                className="d-flex"
                                onClick={() => setToggleMentor(false)}
                              >
                                <div
                                  className="color-green21"
                                  style={{
                                    position: "relative",
                                    left: "-0.35rem",
                                    top: "-0.1rem",
                                  }}
                                >
                                  View Less
                                </div>
                                <div
                                  style={{
                                    cursor: "pointer",
                                    bottom: "0.5rem",
                                    right: "1.25rem",
                                  }}
                                  className="arrowCollapse"
                                >
                                  <img style={{ width: "70%" }} src={arrow} />
                                </div>
                              </div>
                            </td>
                          ) : (
                            ""
                          )}
                        </>
                      );
                    })}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
